import { WebEventPayload } from "../core/types";

export interface TransportBatchPayload {
  communityId: string;
  sentAt: string;
  sdkVersion: string;
  events: WebEventPayload[];
}

export class HttpTransport {
  private endpoint: string;
  private apiKey: string;
  private debug: boolean;

  constructor(endpoint: string, apiKey: string, debug: boolean = false) {
    this.endpoint = endpoint;
    this.apiKey = apiKey;
    this.debug = debug;
  }

  public async sendBatch(payload: TransportBatchPayload): Promise<boolean> {
    const url = `${this.endpoint.replace(/\/$/, "")}/v1/tracking/events/batch`;

    try {
      if (this.debug) {
        console.log(`[Thrico Web SDK] Dispatching batch of ${payload.events.length} event(s) to ${url}`);
      }

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.apiKey}`,
          "X-Thrico-Api-Key": this.apiKey,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        if (this.debug) {
          console.warn(`[Thrico Web SDK] Ingestion request returned status ${response.status}`);
        }
        return false;
      }

      return true;
    } catch (err) {
      if (this.debug) {
        console.error("[Thrico Web SDK] Network error during batch dispatch", err);
      }
      return false;
    }
  }
}
